import Image from 'react-bootstrap/Image';

const Photo = ({ className, src }) => {
    return (
        <Image fluid className={className} src={src} />
    )
}

export default Photo;